import { createStyles, makeStyles, Theme } from "@material-ui/core";

export const copyrightStyles = makeStyles((theme: Theme) =>
    createStyles({
        firstLine: {
            color: theme.colors.neutrals.neutral600,
            marginBottom: 10,
        },

        secondLine: {
            color: theme.colors.neutrals.neutral400,
        },

        link: {
            ...theme.typography.subtitle2,
        },
    })
);
